<template>
<v-form ref="f" lazy-validation v-model="valid">
	<v-container v-if="hotels.length">
		<v-row >
			<v-col class="pt-6 mt-1 pb-6" cols="6" >
				<span class="headline">Показатели отдела персонала</span>
			</v-col>
			<v-col class="pb-6" cols="6" >
				<a-hotel-select v-model="hotelCode"
						  	 :hotels="hotels"
						  	 :loading="hotelLoading"
						  	 @change="getValues">
				</a-hotel-select>
			</v-col>
		</v-row>
		<v-tabs v-model="hf" dark grow slider-color="secondary">
			<v-tab key="0" style="width: 50%;">
				Отработанные часы и среднесписочная численность
			</v-tab>
			<v-tab key="1" style="width: 50%;">
				Приемы и увольнения
			</v-tab>
		</v-tabs>
		<v-tabs v-model="currentTab"
				dark
				grow
				slider-color="secondary">
		    <v-tab v-for="(tab, tabKey) in form"
		           :key="tabKey"
		           ripple>
		    	{{ tab.tabName }}
		    </v-tab>
			<v-tab key="total" ripple>
				TOTAL
			</v-tab>
		    <v-tab-item v-for="(tab, tabKey) in form"
		           		:key="tabKey"
						:transition="false"
						:reverse-transition="false">
				<template v-if="hf == 0">
					<group hf="hours"
						   :tab="tabKey"
						   eo='emp'
						   :groupName="tab.name"
						   :month="monthFormat"
						   :lastMonth="lastMonthFormat"
						   :lines="tab.emp"
						   @data-changed="updateTotals">
						   <!-- :emitTrigger="tab.emitTrigger" -->
					</group>
					<group v-if="tab.out"
						   :tab="tabKey"
						   hf="hours"
						   eo='out'
						   :groupName="tab.name"
						   :month="monthFormat"
						   :lastMonth="lastMonthFormat"
						   :lines="tab.out"
						   @data-changed="updateTotals">
						   <!-- :emitTrigger="tab.emitTrigger" -->
					</group>
				</template>
				<template v-else>
					<group hf="hires"
						   :tab="tabKey"
						   eo='emp'
						   :groupName="tab.name"
						   :month="monthFormat"
						   :lastMonth="lastMonthFormat"
						   :lines="tab.emp"
						   @data-changed="updateTotals">
						   <!-- :emitTrigger="tab.emitTrigger" -->
					</group>
				</template>
		    </v-tab-item>

			<v-tab-item key="total"
						:transition="false"
						:reverse-transition="false">

				<template v-if="hf == 0">
					<group hf="hours"
						   eo='emp'
						   readonly
						   groupName="Итого сотрудники"
						   :month="monthFormat"
						   :lastMonth="lastMonthFormat"
						   :lines="totalEmpLines">
					</group>
					<group hf="hours"
						   eo='out'
						   readonly
						   groupName="Итого аутсорсинг"
						   :month="monthFormat"
						   :lastMonth="lastMonthFormat"
						   :lines="totalOutLines">
					</group>
				</template>
				<template v-else>
					<group hf="hires"
						   eo='emp'
						   groupName="Итого сотрудники"
						   :month="monthFormat"
						   :lastMonth="lastMonthFormat"
						   :lines="totalEmpLines">
					</group>
				</template>
			</v-tab-item>
	    </v-tabs>

		<v-row >
			<v-col class="pb-0 pt-6" cols="12" >
				<v-btn color="primary"
					   class="mr-2"
					   :disabled="!dataChanged"
					   @click="validate">
					Сохранить
				</v-btn>
				<v-btn text color="primary" @click="prevTab" class="mx-2">
					<v-icon>arrow_back_ios</v-icon>
				</v-btn>
				<v-btn text color="primary" @click="nextTab" class="mx-2">
					<v-icon>arrow_forward_ios</v-icon>
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
	<v-container v-else>
		<v-row>
			<v-col>
				<p class="subtitle-1">
					Нет доступных P&L отчетов
				</p>
			</v-col>
		</v-row>
	</v-container>
	<v-dialog v-model="dialogConfirm.show"
			  	persistent
  			  	max-width="1000">
		<v-card>
	  		<v-card-title class="headline">
				Подтверждение
			</v-card-title>
	        <v-card-text>

				<v-row>
					<v-col cols="12">
						<span class="text--primary" v-html="dialogConfirm.html"></span>
					</v-col>
					<v-col cols="12" class="mb-4">
						<span class="text--primary">Вы уверены, что ввели коректные данные?</span>
					</v-col>
				</v-row>

				<v-btn class="mr-2" color="primary" @click="send">
					Да
				</v-btn>
				<v-btn class="mx-2" color="secondary" @click="dialogConfirm.show = false">
					Назад
				</v-btn>
	        </v-card-text>
      	</v-card>
	</v-dialog>
</v-form>
</template>

<script>
	import _ from 'lodash'
	import aHotelSelect from '../../base/AHotelSelect.vue'
	import group from './HrGroup.vue'
	import {api} from '../../../lib/api'
	import {getMonthName, toNum, toStr} from '../../../js/common.js'

	export default {
		components: {
			aHotelSelect,
			group
		},
		data: () => ({
			valid: false,
			dataChanged: false,
			hotelCode: '',
			currentTab: 0,
			hf: 0,
			form: {
				0: {
					tabName: 'Rooms',
					name: 'Номерной фонд',
					// emitTrigger: false,
					emp: {
						name: 'Сотрудники',
						rmFoMgmt: {
							name: 'Front Office Management',
							hours: {
								code: 1501,
								value: ['', '']
							},
							headcount: {
								code: 1551,
								value: ['', '']
							},
							hires: {
								code: 1601,
								value: ['', '']
							},
							fires: {
								code: 1651,
								value: ['', '']
							}
						},
						rmHskpMgmt: {
							name: 'Housekeeping Management',
							hours: {
								code: 1533,
								value: ['', '']
							},
							headcount: {
								code: 1583,
								value: ['', '']
							},
							hires: {
								code: 1633,
								value: ['', '']
							},
							fires: {
								code: 1683,
								value: ['', '']
							}
						},
						rmFo: {
							name: 'Front Office Non-management',
							hours: {
								code: 1502,
								value: ['', '']
							},
							headcount: {
								code: 1552,
								value: ['', '']
							},
							hires: {
								code: 1602,
								value: ['', '']
							},
							fires: {
								code: 1652,
								value: ['', '']
							}
						},
						rmHskp: {
							name: 'Housekeeping Non-management (excl laundry)',
							hours: {
								code: 1504,
								value: ['', '']
							},
							headcount: {
								code: 1554,
								value: ['', '']
							},
							hires: {
								code: 1604,
								value: ['', '']
							},
							fires: {
								code: 1654,
								value: ['', '']
							}
						},
						rmGs: {
							name: 'Guest Services',
							hours: {
								code: 1503,
								value: ['', '']
							},
							headcount: {
								code: 1553,
								value: ['', '']
							},
							hires: {
								code: 1603,
								value: ['', '']
							},
							fires: {
								code: 1653,
								value: ['', '']
							}
						},
						rmRes: {
							name: 'Reservations',
							hours: {
								code: 1505,
								value: ['', '']
							},
							headcount: {
								code: 1555,
								value: ['', '']
							},
							hires: {
								code: 1605,
								value: ['', '']
							},
							fires: {
								code: 1655,
								value: ['', '']
							}
						},
						rmTransp: {
							name: 'Transportation',
							hours: {
								code: 1506,
								value: ['', '']
							},
							headcount: {
								code: 1556,
								value: ['', '']
							},
							hires: {
								code: 1606,
								value: ['', '']
							},
							fires: {
								code: 1656,
								value: ['', '']
							}
						},
					},
					out: {
						name: 'Аутсорсинг',
						rmOutFo: {
							name: 'Front Office Outsourced Labor',
							hours: {
								code: 1507,
								value: ['', '']
							}
						},
						rmOutHskp: {
							name: 'Housekeeping Outsourced Labor',
							hours: {
								code: 1508,
								value: ['', '']
							}
						}
					},
					totals: {
						emp: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						},
						out: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						}
					}
				},
				1: {
					tabName: 'F&B',
					name: 'Служба питания',
					// emitTrigger: false,
					emp: {
						name: 'Сотрудники',
						fbSerMgmt: {
							name: 'F&B Service Management',
							hours: {
								code: 1509,
								value: ['', '']
							},
							headcount: {
								code: 1559,
								value: ['', '']
							},
							hires: {
								code: 1609,
								value: ['', '']
							},
							fires: {
								code: 1659,
								value: ['', '']
							}
						},
						fbKitMgmt: {
							name: 'F&B Kitchen Management',
							hours: {
								code: 1510,
								value: ['', '']
							},
							headcount: {
								code: 1560,
								value: ['', '']
							},
							hires: {
								code: 1610,
								value: ['', '']
							},
							fires: {
								code: 1660,
								value: ['', '']
							}
						},
						fbKit: {
							name: 'F&B Kitchen Non-management',
							hours: {
								code: 1512,
								value: ['', '']
							},
							headcount: {
								code: 1562,
								value: ['', '']
							},
							hires: {
								code: 1612,
								value: ['', '']
							},
							fires: {
								code: 1662,
								value: ['', '']
							}
						},
						fbSer: {
							name: 'F&B Service Non-management',
							hours: {
								code: 1513,
								value: ['', '']
							},
							headcount: {
								code: 1563,
								value: ['', '']
							},
							hires: {
								code: 1613,
								value: ['', '']
							},
							fires: {
								code: 1663,
								value: ['', '']
							}
						},
						fbBnq: {
							name: 'Banqueting',
							hours: {
								code: 1511,
								value: ['', '']
							},
							headcount: {
								code: 1561,
								value: ['', '']
							},
							hires: {
								code: 1611,
								value: ['', '']
							},
							fires: {
								code: 1661,
								value: ['', '']
							}
						},
						fbStw: {
							name: 'Stewarding',
							hours: {
								code: 1514,
								value: ['', '']
							},
							headcount: {
								code: 1564,
								value: ['', '']
							},
							hires: {
								code: 1614,
								value: ['', '']
							},
							fires: {
								code: 1664,
								value: ['', '']
							}
						},
					},
					out: {
						name: 'Аутсорсинг',
						fbOutSer: {
							name: 'F&B Service Outsourced Labor',
							hours: {
								code: 1515,
								value: ['', '']
							}
						},
						fbOutKit: {
							name: 'Kitchen Outsourced Labor',
							hours: {
								code: 1516,
								value: ['', '']
							}
						},
						fbOutStw: {
							name: 'Stewarding Outsourced Labor',
							hours: {
								code: 1517,
								value: ['', '']
							}
						},
					},
					totals: {
						emp: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						},
						out: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						}
					}
				},
				2: {
					tabName: 'W&S',
					name: 'Фитнес и спа',
					// emitTrigger: false,
					emp: {
						name: 'Сотрудники',
						wsMgmt: {
							name: 'Wellness & Spa Management',
							hours: {
								code: 1531,
								value: ['', '']
							},
							headcount: {
								code: 1581,
								value: ['', '']
							},
							hires: {
								code: 1631,
								value: ['', '']
							},
							fires: {
								code: 1681,
								value: ['', '']
							}
						},
						ws: {
							name: 'Wellness & Spa Non-management',
							hours: {
								code: 1529,
								value: ['', '']
							},
							headcount: {
								code: 1579,
								value: ['', '']
							},
							hires: {
								code: 1629,
								value: ['', '']
							},
							fires: {
								code: 1679,
								value: ['', '']
							}
						},
					},
					out: {
						name: 'Аутсорсинг',
						wsOut: {
							name: 'Wellness & Spa Outsourced Labor',
							hours: {
								code: 1535,
								value: ['', '']
							}
						},
					},
					totals: {
						emp: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						},
						out: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						}
					}
				},
				3: {
					tabName: 'A&G',
					name: 'Администрация',
					// emitTrigger: false,
					emp: {
						name: 'Сотрудники',
						agMgmt: {
							name: 'A&G Management',
							hours: {
								code: 1518,
								value: ['', '']
							},
							headcount: {
								code: 1568,
								value: ['', '']
							},
							hires: {
								code: 1618,
								value: ['', '']
							},
							fires: {
								code: 1668,
								value: ['', '']
							}
						},
						agFin: {
							name: 'A&G Finance',
							hours: {
								code: 1519,
								value: ['', '']
							},
							headcount: {
								code: 1569,
								value: ['', '']
							},
							hires: {
								code: 1619,
								value: ['', '']
							},
							fires: {
								code: 1669,
								value: ['', '']
							}
						},
						agGen: {
							name: 'General Support',
							hours: {
								code: 1520,
								value: ['', '']
							},
							headcount: {
								code: 1570,
								value: ['', '']
							},
							hires: {
								code: 1620,
								value: ['', '']
							},
							fires: {
								code: 1670,
								value: ['', '']
							}
						},
						agHr: {
							name: 'Human Resources',
							hours: {
								code: 1521,
								value: ['', '']
							},
							headcount: {
								code: 1571,
								value: ['', '']
							},
							hires: {
								code: 1621,
								value: ['', '']
							},
							fires: {
								code: 1671,
								value: ['', '']
							}
						},
						agPurch: {
							name: 'Purchasing',
							hours: {
								code: 1522,
								value: ['', '']
							},
							headcount: {
								code: 1572,
								value: ['', '']
							},
							hires: {
								code: 1622,
								value: ['', '']
							},
							fires: {
								code: 1672,
								value: ['', '']
							}
						},
						agSec: {
							name: 'Security',
							hours: {
								code: 1523,
								value: ['', '']
							},
							headcount: {
								code: 1573,
								value: ['', '']
							},
							hires: {
								code: 1623,
								value: ['', '']
							},
							fires: {
								code: 1673,
								value: ['', '']
							}
						},
					},
					out: {
						name: 'Аутсорсинг',
						agOut: {
							name: 'A&G Outsourced Labor',
							hours: {
								code: 1536,
								value: ['', '']
							}
						},
					},
					totals: {
						emp: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						},
						out: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						}
					}
				},
				4: {
					tabName: 'IT',
					name: 'IT Системы',
					// emitTrigger: false,
					emp: {
						name: 'Сотрудники',
						it: {
							name: 'IT',
							hours: {
								code: 1524,
								value: ['', '']
							},
							headcount: {
								code: 1574,
								value: ['', '']
							},
							hires: {
								code: 1624,
								value: ['', '']
							},
							fires: {
								code: 1674,
								value: ['', '']
							}
						},
					},
					totals: {
						emp: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						}
					}
				},
				5: {
					tabName: 'S&M',
					name: 'Продажи и маркетинг',
					// emitTrigger: false,
					emp: {
						name: 'Сотрудники',
						sm: {
							name: 'Sales & Marketing',
							hours: {
								code: 1525,
								value: ['', '']
							},
							headcount: {
								code: 1575,
								value: ['', '']
							},
							hires: {
								code: 1625,
								value: ['', '']
							},
							fires: {
								code: 1675,
								value: ['', '']
							}
						},
					},
					totals: {
						emp: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						}
					}
				},
				6: {
					tabName: 'POM',
					name: 'Инженерная служба',
					// emitTrigger: false,
					emp: {
						name: 'Сотрудники',
						pom: {
							name: 'Property Operation and Maintenance',
							hours: {
								code: 1526,
								value: ['', '']
							},
							headcount: {
								code: 1576,
								value: ['', '']
							},
							hires: {
								code: 1626,
								value: ['', '']
							},
							fires: {
								code: 1676,
								value: ['', '']
							}
						}
					},
					out: {
						name: 'Аутсорсинг',
						pomOut: {
							name: 'POM Outsourced Labor',
							hours: {
								code: 1534,
								value: ['', '']
							}
						}
					},
					totals: {
						emp: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						},
						out: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						}
					}
				},
				7: {
					tabName: 'HL',
					name: 'Прачечная',
					// emitTrigger: false,
					emp: {
						name: 'Сотрудники',
						hl: {
							name: 'House Laundry',
							hours: {
								code: 1527,
								value: ['', '']
							},
							headcount: {
								code: 1577,
								value: ['', '']
							},
							hires: {
								code: 1627,
								value: ['', '']
							},
							fires: {
								code: 1677,
								value: ['', '']
							}
						},
					},
					out: {
						name: 'Аутсорсинг',
						hlOut: {
							name: 'House Laundry Outsourced Labor',
							hours: {
								code: 1537,
								value: ['', '']
							}
						},
					},
					totals: {
						emp: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						},
						out: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						}
					}
				},
				8: {
					tabName: 'SD',
					name: 'Столовая',
					// emitTrigger: false,
					emp: {
						name: 'Сотрудники',
						sd: {
							name: 'Staff Dining',
							hours: {
								code: 1528,
								value: ['', '']
							},
							headcount: {
								code: 1578,
								value: ['', '']
							},
							hires: {
								code: 1628,
								value: ['', '']
							},
							fires: {
								code: 1678,
								value: ['', '']
							}
						},
					},
					out: {
						name: 'Аутсорсинг',
						sdOut: {
							name: 'Staff Dining Outsourced Labor',
							hours: {
								code: 1538,
								value: ['', '']
							}
						},
					},
					totals: {
						emp: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						},
						out: {
							hours: ['0', '0'],
							headcount: ['0', '0'],
							hires: ['0', '0'],
							fires: ['0', '0']
						}
					}
				}
			},
			dc: 60,
			hotels: null,
			valuesLoading: false,
			hotelLoading: false,
			dialogConfirm: {
				show: false,
				html: ''
			}
		}),
		computed: {
			totalEmpLines() {
				return _.mapValues(this.form, tab => {
					return {
						name: tab.name,
						hours: {
							value: tab.totals.emp.hours
						},
						headcount: {
							value: tab.totals.emp.headcount
						},
						hires: {
							value: tab.totals.emp.hires
						},
						fires: {
							value: tab.totals.emp.fires
						},
					}
				})
			},
			totalOutLines() {
				return _.mapValues(_.filter(this.form, tab => tab.totals.out), tab => {
					return {
						name: tab.name,
						hours: {
							value: tab.totals.out.hours
						},
						headcount: {
							value: tab.totals.out.headcount
						},
						hires: {
							value: tab.totals.out.hires
						},
						fires: {
							value: tab.totals.out.fires
						},
					}
				})
			},
			selectedHotel() {
				let index = this.hotels.map(hotel => (hotel.code || null)).indexOf(this.hotelCode)
				return this.hotels[index]
			},
			month() {
				if (this.selectedHotel && this.selectedHotel.month) return this.selectedHotel.month
				else return undefined
			},
			monthFormat() {
				if (this.month) return getMonthName(this.month.substr(5, 2), 'Ul')
				else return undefined
			},
			lastMonthFormat() {
				if (!this.month) return undefined
				let d = this.month.substr(5, 2) - 1
				if (d == 0) d = 12
				return getMonthName(d, 'Ul')
			}
		},
		created() {
			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			this.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
			// this.hotelCode = 'TEST'

			this.apiFirstCall()
		},
		methods: {
			nextTab() {
				this.currentTab = (this.currentTab + 1) % 10
			},
			prevTab() {
				this.currentTab = (this.currentTab + 9) % 10
			},
			calcTotals() {
				for (let tab in this.form) {
					this.form[tab].totals.emp.hours = [0, 0]
					this.form[tab].totals.emp.headcount = [0, 0]
					this.form[tab].totals.emp.hires = [0, 0]
					this.form[tab].totals.emp.fires = [0, 0]

					for (let line in this.form[tab].emp) {
						if (line != 'name') {
							this.form[tab].totals.emp.hours[0] += toNum(this.form[tab].emp[line].hours.value[0])
							this.form[tab].totals.emp.hours[1] += toNum(this.form[tab].emp[line].hours.value[1])
							this.form[tab].totals.emp.headcount[0] += toNum(this.form[tab].emp[line].headcount.value[0])
							this.form[tab].totals.emp.headcount[1] += toNum(this.form[tab].emp[line].headcount.value[1])
							this.form[tab].totals.emp.hires[0] += toNum(this.form[tab].emp[line].hires.value[0])
							this.form[tab].totals.emp.hires[1] += toNum(this.form[tab].emp[line].hires.value[1])
							this.form[tab].totals.emp.fires[0] += toNum(this.form[tab].emp[line].fires.value[0])
							this.form[tab].totals.emp.fires[1] += toNum(this.form[tab].emp[line].fires.value[1])
						}
					}

					this.form[tab].totals.emp.hours[0] = toStr(this.form[tab].totals.emp.hours[0], 0)
					this.form[tab].totals.emp.hours[1] = toStr(this.form[tab].totals.emp.hours[1], 0)
					this.form[tab].totals.emp.headcount[0] = toStr(this.form[tab].totals.emp.headcount[0], 0)
					this.form[tab].totals.emp.headcount[1] = toStr(this.form[tab].totals.emp.headcount[1], 0)
					this.form[tab].totals.emp.hires[0] = toStr(this.form[tab].totals.emp.hires[0], 0)
					this.form[tab].totals.emp.hires[1] = toStr(this.form[tab].totals.emp.hires[1], 0)
					this.form[tab].totals.emp.fires[0] = toStr(this.form[tab].totals.emp.fires[0], 0)
					this.form[tab].totals.emp.fires[1] = toStr(this.form[tab].totals.emp.fires[1], 0)

					if (this.form[tab].out) {
						this.form[tab].totals.out.hours = [0, 0]

						for (let line in this.form[tab].out) {
							if (line != 'name') {
								this.form[tab].totals.out.hours[0] += toNum(this.form[tab].out[line].hours.value[0])
								this.form[tab].totals.out.hours[1] += toNum(this.form[tab].out[line].hours.value[1])
							}
						}

						this.form[tab].totals.out.hours[0] = toStr(this.form[tab].totals.out.hours[0], 0)
						this.form[tab].totals.out.hours[1] = toStr(this.form[tab].totals.out.hours[1], 0)
					}
				}
			},
			updateTotals(emitter) {
				this.dataChanged = true
				// this.form[emitter.tab].emitTrigger = false

				if (emitter.hf == 'hours') {
					this.form[emitter.tab].totals[emitter.eo].hours = emitter.totals.hours
					this.form[emitter.tab].totals[emitter.eo].headcount = emitter.totals.headcount
				}
				else {
					this.form[emitter.tab].totals[emitter.eo].hires = emitter.totals.hires
					this.form[emitter.tab].totals[emitter.eo].fires = emitter.totals.fires
				}
			},
			validate() {
				if (!this.$refs.f.validate()) return

				let notices = [];

				let anyHiresOrFires = false
				for (let tab in this.totalEmpLines) {
					if (this.totalEmpLines[tab].hires.value[1] > 0 || this.totalEmpLines[tab].fires.value[1] > 0) {
						anyHiresOrFires = true
						break
					}
				}

				if (!anyHiresOrFires) {
					notices.push('Число приемов и увольнений за месяц равно нулю.')
				}

				for (let tab in this.form) {
					for (let line in this.form[tab].emp) {
						if (line == 'name') continue
						let hours = toNum(this.form[tab].emp[line].hours.value[1])
						let headcount = toNum(this.form[tab].emp[line].headcount.value[1])
						let hoursPerHead = (hours / headcount).toFixed(0)

						if (!headcount && hours) {
							notices.push('По отделу '
								+ this.form[tab].emp[line].name + ' введены отработанные часы, но не указана среднесписочная численность.')
						}
						else if (headcount && !hours) {
							notices.push('По отделу '
								+ this.form[tab].emp[line].name + ' введена среднесписочная численность, но не указаны отработанные часы.')
						}
						else if (hours && hoursPerHead < 50 || hoursPerHead > 200) {
							notices.push('Соотношение отработанных часов к среднесписочной численности по отделу '
								+ this.form[tab].emp[line].name + ' составляет ' + hoursPerHead)
						}
					}

				}

				if (notices.length) {
					this.dialogConfirm.show = true
					this.dialogConfirm.html = '<p>' + notices.join('</p><p>') + '</p>'
				}
				else {
					this.send()
				}

			},
			send() {
				this.dialogConfirm.show = false
				this.$store.dispatch('dialogLoadingStart')

				api.post('pl/set_hod_data', {
					form: this.trimmedForm(),
					hotelCode: this.hotelCode,
					month: this.selectedHotel.month,
					dc: this.dc,
					readyDept: 'hr'
				})
				.then(response => {

					this.$store.dispatch('dialogLoadingStop')
					this.$store.dispatch('dialogDone')
					this.dataChanged = false

				}, error => {})
			},
			apiFirstCall() {
				this.hotelLoading = true
				api.post('pl/get_pending_report_month', { hotels: this.hotels })
				.then(response => {
					this.hotelLoading = false

					this.hotels = response.data.hotels
					this.hotels = this.hotels.filter(hotel => !!hotel.month)
					if (this.hotels.length == 0) return

					this.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
					// this.hotelCode = 'TEST'

					this.getValues()

				}, error => {})
			},
			getValues(hotelCode) {
				this.valuesLoading = true

				// if (!hotelCode) hotelCode = this.hotelCode
				// let index = this.hotels.map(hotel => (hotel.code || null)).indexOf(hotelCode)
				// let selectedHotel = this.hotels[index]
				// let month = selectedHotel.month

				api.post('pl/get_hod_data', {
					form: this.trimmedForm(),
					hotelCode: this.hotelCode,
					month: this.selectedHotel.month,
					dc: this.dc,
				})
				.then(response => {
					this.valuesLoading = false

					for (let tab in this.form) {
						for (let group in this.form[tab]) {
							if (group != 'emp' && group != 'out') {
								continue
							}
							for (let line in this.form[tab][group]) {
								if (line == 'name') {
									continue
								}
								if (!this.form[tab][group][line] || !response.data.form[tab][group][line]) {
									console.log(line)
								}
								if (this.form[tab][group][line].hours) {
									this.form[tab][group][line].hours.value = response.data.form[tab][group][line].hours.value
								}
								if (this.form[tab][group][line].headcount) {
									this.form[tab][group][line].headcount.value = response.data.form[tab][group][line].headcount.value
								}
								if (this.form[tab][group][line].hires) {
									this.form[tab][group][line].hires.value = response.data.form[tab][group][line].hires.value
								}
								if (this.form[tab][group][line].fires) {
									this.form[tab][group][line].fires.value = response.data.form[tab][group][line].fires.value
								}
							}
						}
						// this.form[tab].emitTrigger = true
					}
					this.calcTotals()
					this.$refs.f.resetValidation()
					this.dataChanged = false

				}, error => {})
			},
			recursiveTrim(form) {
				for (let prop in form) {
					if (prop == 'hours' || prop == 'headcount'
						|| prop == 'hires' || prop == 'fires'
					) {
						continue
					}
					else if (_.isObject(form[prop])) {
						this.recursiveTrim(form[prop])
					}
					else {
						delete form[prop]
					}
				}
			},
			trimmedForm() {
				let newForm = _.cloneDeep(this.form)

				this.recursiveTrim(newForm)

				return newForm
			}
		}
	}
</script>
